const WIDTH_QUERY = /([?&]w=)\d+/;

const defaultWidths = [480, 640, 960, 1280, 1600, 2000, 2400];

const maxWidthFromUrl = (src) => {
  const match = src.match(/[?&]w=(\d+)/);
  return match ? Number(match[1]) : null;
};

export const IMAGE_SIZES = {
  full: '100vw',
  half: '(min-width: 768px) 50vw, 100vw',
  twoColumn: '(min-width: 768px) 50vw, 100vw',
  third: '(min-width: 768px) 33vw, 100vw',
  quarter: '(min-width: 768px) 25vw, 50vw',
  roomHero: '(min-width: 768px) 67vw, 100vw',
  sliderCard: '(min-width: 1024px) 560px, (min-width: 768px) 520px, 82vw',
};

export const responsiveImageProps = (src, sizes = IMAGE_SIZES.full, widths = defaultWidths) => {
  if (!src || !src.includes('images.unsplash.com') || !WIDTH_QUERY.test(src)) {
    return { src, decoding: 'async' };
  }

  const maxWidth = maxWidthFromUrl(src);
  const selectedWidths = widths.filter((width) => !maxWidth || width <= maxWidth);

  return {
    src,
    srcSet: selectedWidths
      .map((width) => `${src.replace(WIDTH_QUERY, `$1${width}`)} ${width}w`)
      .join(', '),
    sizes,
    decoding: 'async',
  };
};
